import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterBar } from '@saucelabs/ds-filters';
import { ViewSelector, constants as multiviewGridConstants } from '@saucelabs/sl-component-multiview-grid';

import SearchFilter from './SearchFilter';
import PlatformFilter from './PlatformFilter';
import OsVersionsFilter from './OsVersionsFilter';
import ManufacturersFilter from './ManufacturersFilter';
import MiscFilter from './MiscFilters';
import DeviceSortBar from './DeviceSortBar';
import actions from '../../actions';
import constants from '../../constants';
import selectors from '../../selectors';
import { CONFIGURATION_TEST_TYPES } from '../../../../constants';
import { trackEvent, MANUAL_EVENTS } from '../../../../tracking';
import { ValueOf } from '../../../../globalTypes';

const {
  MOBILE_SELECTION_FILTER_CATEGORY: FILTER_CATEGORY,
} = constants;

// TODO: Move this type definition to the actions or reducers file as soon as they are .ts files
type FilterUpdate = {
  category: ValueOf<typeof FILTER_CATEGORY>;
  values: (string | number)[];
}[];

const DeviceFilterBar: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    activeFilters,
    currentView,
    mobileAppConfiguration,
    testType,
  } = useSelector(selectors.mobileSelectionSelector);

  return (
    <div
      className="flex flex-wrap"
      data-qa="device-filter-bar"
    >
      <SearchFilter />
      <div className="flex-grow mt-1">
        <FilterBar
          onReset={() => {
            void dispatch(actions.clearFilters());

            // If an app is selected, reset the platform filter immediately after clearing.
            // Clearing this would not make sense in this case.
            if (testType === CONFIGURATION_TEST_TYPES.APP && !!mobileAppConfiguration) {
              dispatch(actions.setFilters([{
                category: FILTER_CATEGORY.OS,
                values: [...activeFilters.get(FILTER_CATEGORY.OS)],
              }]));
            }
          }}
          showResetButton
          sortBar={<DeviceSortBar />}
        >
          <PlatformFilter />
          <OsVersionsFilter />
          <ManufacturersFilter />
          <MiscFilter />
        </FilterBar>
      </div>
      <div className="flex items-center ml-auto pl-2 pt-1">
        <ViewSelector
          availableViewTypes={[
            multiviewGridConstants.VIEW_TYPE.SMALL_BOX,
            multiviewGridConstants.VIEW_TYPE.LIST,
          ]}
          currentView={currentView}
          onChangeView={(newView) => {
            trackEvent(MANUAL_EVENTS.RDC_GRID_VIEW_TYPE_CHANGED, {
              prevView: currentView,
              newView,
            });
            dispatch(actions.selectMobileSelectionCurrentView(newView));
          }}
        />
      </div>
    </div>
  );
};

export default DeviceFilterBar;
export type {
  FilterUpdate,
};
